/**
 * True when the user has asked the OS to reduce motion.
 *
 * Read once as a lazy `useState` initialiser rather than subscribed to, which
 * matches how the existing callers use it: the preference almost never changes
 * mid-session, and re-rendering a page on a media-query flip is not worth the
 * listener. Purely CSS-driven animations should use the
 * `@media (prefers-reduced-motion: reduce)` block instead of this helper.
 */
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
